/* global angular */

var ngModule = angular.module('trends');

ngModule.directive('redirectTrend', ['$state', function ($state) {
    return {
        restrict: 'A',
        scope: false,
        link: function (scope, element, attrs) {
            $state.go('trend', {item_id: attrs.redirectTrend});
        }
    };
}]);
